export const aciFan = {
    iconName: 'fan',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 25' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M8.198 4.577a6.772 6.772 0 119.578 9.578 6.772 6.772 0 01-9.578-9.578zm4.79-.983a5.772 5.772 0 100 11.544 5.772 5.772 0 000-11.544z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M6.215 9.367a.5.5 0 01.5-.5h12.544a.5.5 0 110 1H6.715a.5.5 0 01-.5-.5z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M16.374 3.5a.5.5 0 01.183.684l-6.272 10.863a.5.5 0 11-.866-.5L15.69 3.684a.5.5 0 01.683-.183z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M9.602 3.5a.5.5 0 01.683.184l6.272 10.863a.5.5 0 01-.866.5L9.419 4.184a.5.5 0 01.183-.683zM9.958 19.617a6.772 6.772 0 018.446 1.994.5.5 0 01-.4.8H7.97a.5.5 0 01-.4-.8 6.773 6.773 0 012.389-1.994zm3.029.285a5.773 5.773 0 00-3.892 1.51h7.783a5.772 5.772 0 00-3.891-1.51z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M12.988 15.137a.5.5 0 01.5.5V19.4a.5.5 0 01-1 0v-3.763a.5.5 0 01.5-.5z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
